import { Role } from "@/constants/enums/user/role";
import { lazyWithRetry } from "@/router/lazyWithRetry";
import { RouteConfig } from "@/router/types";

const AdminLayout = lazyWithRetry(
  () => import("@/components/layouts/AdminLayout"),
);
const Dashboard = lazyWithRetry(() => import("@/pages/admin/dashboard"));
const UserManagement = lazyWithRetry(
  () => import("@/pages/admin/userManagement"),
);
const AuditSearch = lazyWithRetry(() => import("@/pages/admin/auditSearch"));
const RolesManagement = lazyWithRetry(
  () => import("@/pages/admin/roleManagement/index"),
);
const RecordSetManagement = lazyWithRetry(
  () => import("@/pages/admin/recordSetManagement"),
);
const GlobalConfig = lazyWithRetry(
  () => import("@/pages/admin/globalConfiguration/index"),
);
const UserDataBridge = lazyWithRetry(
  () => import("@/pages/admin/userDataBridge"),
);
const WorkItemDetails = lazyWithRetry(
  () => import("@/pages/admin/auditSearch/components/WorkItemDetails"),
);
const Reports = lazyWithRetry(() => import("@/pages/admin/reports"));
const MyAccount = lazyWithRetry(() => import("@/pages/myAccount"));
const BatchIngestion = lazyWithRetry(() => import("@/pages/batchIngestion"));
const BatchDetails = lazyWithRetry(
  () => import("@/pages/batchIngestion/details"),
);
const DocumentTypeForm = lazyWithRetry(
  () =>
    import("@/pages/admin/globalConfiguration/documentTypes/components/DocumentTypeForm"),
);

const AdminRoutes: RouteConfig[] = [
  {
    path: "/admin",
    layout: AdminLayout,
    requiredRole: Role.ADMIN,
    children: [
      { path: "dashboard", component: Dashboard },
      { path: "users", component: UserManagement },
      { path: "audit", component: AuditSearch },
      { path: "roles", component: RolesManagement },
      { path: "record-sets", component: RecordSetManagement },
      { path: "config", component: GlobalConfig },
      { path: "user-data-bridge", component: UserDataBridge },
      { path: "reports", component: Reports },
      { path: "batch-ingestion", component: BatchIngestion },
      { path: "batch-ingestion/:batchId", component: BatchDetails },
      { path: "audit/:workItemId", component: WorkItemDetails },
      {
        path: "config/:recordSetId/document-type",
        component: DocumentTypeForm,
      },
      {
        path: "config/:recordSetId/document-type/:documentTypeId",
        component: DocumentTypeForm,
      },
      { path: "account", component: MyAccount },
      { path: "", index: true, redirectTo: "/admin/dashboard" },
    ],
  },
];

export default AdminRoutes;
